import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { ShieldCheck } from "lucide-react";

export function MfaStep({ mfaToken, onVerified, onCancel }) {
  const [code, setCode] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/mfa/verify", { mfa_token: mfaToken, code });
      onVerified(data);
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="mfa-step">
      <div className="flex items-center gap-2 text-emerald-800">
        <ShieldCheck className="w-5 h-5" />
        <span className="font-semibold text-sm">Two-step verification</span>
      </div>
      <p className="text-sm text-stone-600">Enter the 6-digit code from your authenticator app.</p>
      <input data-testid="mfa-code" autoFocus inputMode="numeric" pattern="[0-9 ]*" maxLength={7} required value={code}
        onChange={(e) => setCode(e.target.value)} placeholder="123 456"
        className="w-full px-4 py-3 rounded-xl border border-stone-300 font-mono text-2xl tracking-[0.3em] text-center focus:border-amber-600 focus:ring-2 focus:ring-amber-200 outline-none" />
      {err && <div data-testid="mfa-error" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{err}</div>}
      <button data-testid="mfa-submit" type="submit" disabled={busy || code.replace(/\s/g, "").length < 6} className="amber-btn w-full disabled:opacity-50">
        {busy ? "Checking…" : "Verify & sign in"}
      </button>
      <button type="button" data-testid="mfa-cancel" onClick={onCancel} className="w-full text-xs text-stone-500 hover:text-stone-800">Back to sign in</button>
    </form>
  );
}
